const HTTP_UNPROCESSABLE_ENTITY = 422;

const BLOCK_HOME_CREATION_ACTION = 'block_home_creation';

// Legacy API answers `{ errors: [...] }`. Direct calls (jQuery) expose it as `responseJSON`,
// calls through the BFF (heFetch) wrap it: `HeError.errorData.message`.
const getErrorPayload = (error) => {
    if (!error) {
        return null;
    }
    if (error.status === HTTP_UNPROCESSABLE_ENTITY) {
        return error.responseJSON || null;
    }
    if (error.code === HTTP_UNPROCESSABLE_ENTITY) {
        return error.errorData?.message || null;
    }
    return null;
};

/**
 * Whether an API error is the legacy geo-restriction block on home creation/edition (EX-1011).
 * The server message is intentionally ignored: the displayed copy must stay generic (EX-1755).
 */
export const isGeoRestrictionBlockingError = (error) => {
    const errors = getErrorPayload(error)?.errors;
    if (!Array.isArray(errors)) {
        return false;
    }
    return errors.some(
        (restriction) => restriction?.blocking === true && restriction?.action === BLOCK_HOME_CREATION_ACTION
    );
};
